<template>
    <div ref="SubHeading">
        <br>
        <h2><slot></slot></h2>
    </div>
</template>
<script>
export default {
    name:"SubHeading"
}
</script>

<style scoped>
    h2{
        opacity: 0.86;
        background-color: #BADBC7;
        padding-left: 1rem;
        font-size: 1.5rem;
        color: #223546;
        margin-bottom: .5rem;
        font-family: inherit;
        font-weight: 500;
        line-height: 1.2;
    }
</style>